module.exports = __webpack_public_path__ + "img/REG_ALIM_AUTRE_LISTE_NOM.23cb719a.svg";